
import { useContext, useMemo } from "react";
import { Loading } from "../../../components/loading";
import { Outlet, useParams } from "react-router-dom";
import { BallotProvider } from "./ballot.context";
import { ElectionContext } from "../election.context";

export const BallotLayout = () => {
  const { ballot_id } = useParams();

  const { ballots } = useContext(ElectionContext);

  const ballot = useMemo(
    () => ballots.find((bp) => bp.id === ballot_id),
    [ballots, ballot_id]
  );

  if (!ballot) {
    return <Loading source="QuestionPanel" />;
  }

  return (
    <BallotProvider ballot={ballot}>
      <Outlet />
    </BallotProvider>
  );
};
